import { useBeforeUnload } from 'react-router-dom'
import { useCallback } from 'react'
import { setLoginStatus } from 'src/store/Reducer/common/commonSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'

const usePageLayoutBeforeUnloadHook = () => {
  const dispatch = useAppDispatch()
  useBeforeUnload(useCallback((e) => dispatch(setLoginStatus(false)), [dispatch]))
}
export default usePageLayoutBeforeUnloadHook
